export default {
  navbar: {
    index: '首页',
    center: '产品中心',
    advanced: '联系我们',
    solve: '我们的工厂',
    about: '我们'
  },
  prod: {
    save: '消费级产品',
    dd: '定制产品',
    fz: '工控级产品',
    xl: 'WBBGA系列封装'
  },
  Productcenter: {
    name: '产品中心',
  },
  submitoBJ:{
    name: '提交',
  },
  Ourfactory: {
    name: '我们的工厂',
  },
  Home: {
    ho1: '各款产品，来称心选购',
    ho2: '公司介绍',
    ho3: '企业发展历程',
  },
  introduction: {
    line: '杭州鑫晟发控股有限公司',
    line1: '杭州鑫晟发控股有限公司成立于2023年，是一家专注半导体电子信息产业、多领域布局协同发展的公司。公司坚持以“客户需求”为导向，以“专业、高效、个性化”的特色服务于全球各大知名企业以及终端消费者，致力于成为客户最信赖的集成化服务方案合作伙伴。目前公司着重与半导体产业开发，原料存货及设备的采销及进出口业务和消费类产品的全球贸易。提供存储一体解决方案，主要产品包括NAND FLASH存储品，专业闪存卡、SSD以及NAS等。',
    line2: '广交会',
    line3: '借势广交会全球平台，双届深耕海外市场，以国产化实力与国风美学铸就品牌吸引力\n' +
      '2023 年 10 月至 2025 年 10 月，公司携手中坚工厂伙伴，连续两届重磅亮相中国进出口商品交易会（广交会）这一连接全球贸易的核心枢纽，以 “技术国产化 + 设计国风化” 的双轮驱动策略，向世界递出中国存储方案的特色名片。',
    line4: '自有品牌',
    line5: '战略布局 C 端市场：双品牌焕新启航，重塑存储解决方案新标杆\n' +
      '2024 年 10 月，公司立足服务行业用户的深厚积淀，怀揣 “让优质存储体验惠及更广泛消费群体” 的战略远见，正式开启家用场景解决方案的全新征程。为精准匹配不同客群需求，我们匠心打造并注册 Xincerfarm（鑫晟发）与 Krystaic（晶太）两大自有品牌，以双品牌矩阵构建差异化竞争优势 —— 其中，Xincerfarm（鑫晟发）聚焦国内高端消费市场，凭借定制化设计与极致性能，满足高净值用户对存储品质的严苛要求；Krystaic（晶太）则面向全球海外市场，以国际化视野融合本地化需求，提供适配多元场景的高效存储方案。'
  },
  introduction2: {
    line: '杭州鑫晟发控股有限公司',
    line1: '杭州鑫晟发控股有限公司成立于2023年，是一家专注半导体电子信息产业、多领域布局协同发展的公司。公司坚持以“客户需求”为导向，以“专业、高效、个性化”的特色服务于全球各大知名企业以及终端消费者，致力于成为客户最信赖的集成化服务方案合作伙伴。目前公司着重与半导体产业开发，原料存货及设备的采销及进出口业务和消费类产品的全球贸易。提供存储一体解决方案，主要产品包括NAND FLASH存储品，专业闪存卡、SSD以及NAS等。',
    line2: '巴西展',
    line3: '借势巴西展会破局，实现市场拓展、代理落地与品牌深耕三重突破',
    line4: '香港展',
    line5: '亮相香港展会,PSSD 新品首发引爆关注，凭硬实力斩获市场广泛好评'
  },
  Product: {
    pro: '固态硬盘',
    pro1: '移动固态硬盘',
    pro2: 'U盘',
    pro3: '内存条',
    pro4: '私有云储存',
    pro5: '内存卡',
  },
  footer: {
    foo: '杭州市滨江区西兴街道聚业路25号浙江新大大楼26楼',
    foo1: '外贸业务',
    foo2: '联系电话',
    foo3: '联系邮箱',
    foo4: '国内业务',
  },
  productcenter: {
    cen: '全部产品',
    cen1: '已选',
    cen2: '消费级产品',
    cen3: '工控级产品',
    cen4: '提交意向单',
    cen5: '产品详情',
  },
  Ares: {
    name: '火星 阿瑞斯Ares ',
    intro: 'MRT3500，PCIE3.0系列产品，采用高品质的TLC颗粒以及石墨烯散热贴加强散热，瞬时最大读写速度可达3500MB/S',
  },
  Poseidon: {
    name: '海王星 波塞东Poseidon',
    intro: 'NET7000，PCIE4.0系列产品，采用高品质的TLC颗粒以及石墨烯散热贴加强散热，瞬时最大读写速度可到7450MB/S',
  },
  core: {
    cor: '工厂概括',
    cor1: '2023年，杭州鑫晟发控股有限公司，持股浙江甚湖科技有限公司，主导M2C,M2B贸易，依托于工厂先进封装制造技术，以纳米级高精度在闪存（Flash\n' +
      '                Memory），动态随机存取器（DRAM）等关键领域有突破性产品研发生产，为物联网数据基础、智慧化城市 、家庭云智存等领域提供核心应用解决方案。',
    cor2: '自有工厂',
    cor3: '工厂实景和操作车间',
    cor4: '工厂介绍',
  },
  about: {
    ab: '关于我们',
    ab1: '经典客户案例',
    ab2: '公司与2023年与中国制造网（Made In China）进行了深度绑定合作，成为其钻石合作伙伴，合作期间为近100家公司和客户提供了存储解决方案，与多个中东国家的贸易商进行了深度合作。',
    ab3: '企业文化',
    ab4: '公司始终坚持“稳健发展、携手共赢”的发展思路，秉承“阳光、规范、品质、分享”的经营理念，立足当下\n' +
      '            ，着眼未来，稳扎稳打深耕传统行业，同时不遗余力的拓展新兴产业尤其是高科技、前沿行业。',
  },
  ContactUs: {
    cont0: '联系我们',
    cont: '地址：杭州市滨江区西兴街道聚业路25号浙江新大大楼26楼',
    cont1: '外贸业务',
    cont2: '联系电话',
    cont3: '联系邮箱',
    cont4: '国内业务',
    cont5: '联系电话',
    cont6: '联系邮箱',
  },
  cg: {
    cg: '请填写采购意向单',
    cg1: '注册类型',
    cg2: '公司名称',
    cg3: '公司地址',
    cg4: '联系人姓名',
    cg5: '联系人电话',
    cg6: '联系人邮箱',
    cg7: '提交',
  },
  Aphrodite: {
    name: '金星 阿佛洛狄忒Aphrodite',
    intro: 'VES500，SATA3.0系列产品，采用高品质的TLC颗粒，瞬时最大读写速度可到550MB/S',
  },
  Blackhead: {
    name: '黑头U盘',
    intro: 'VES500，SATA3.0系列产品，采用高品质的TLC颗粒，瞬时最大读写速度可到550MB/S',
  },
  Rotate: {
    name: '旋转U盘',
    intro: 'U320C，USB3.2和TYPE C双头接口，金属材质，旋转防尘',
  },
  ShuixingTotate: {
    name: '水星 赫耳墨斯',
    intro: '移动存储、磁吸便捷、全球定位',
  },
  huoxing: {
    name: '火星 阿瑞斯Ares ',
    intro: 'MRT3500，PCIE3.0系列产品，采用高品质的TLC颗粒以及石墨烯散热贴加强散热，瞬时最大读写速度可达3500MB/S',
  },
  Hermes: {
    name: '水星 赫耳墨斯Hermes',
    intro: '希腊神话中，被称为赫耳墨斯Hermes，代表速度之神。水星最接近太阳，是体积和质量最小的行星，常和太阳同时出。因其体积最小速度又快的特性，可当做便携PSSD产品的代号。',
  },
  haiwangxing: {
    name: '海王星 波塞东Poseidon',
    intro: 'NET7000，PCIE4.0系列产品，采用高品质的TLC颗粒以及石墨烯散热贴加强散热，瞬时最大读写速度可到7450MB/S',
  },
  jingxing: {
    name: '金星 阿佛洛狄忒Aphrodite',
    intro: 'VES500，SATA3.0系列产品，采用高品质的TLC颗粒，瞬时最大读写速度可到550MB/S',
  },
  heitoupan: {
    name: '黑头U盘',
    intro: 'U301，金属材质，USB3.0接口，容量最大可到256G',
  },
  xuanzhuangupan: {
    name: '旋转U盘',
    intro: 'U320C，USB3.2和TYPE C双头接口，金属材质，旋转防尘',
  },
  shuixing:{
    name: '水星 赫耳墨斯',
    intro : "水星 赫耳墨斯"
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js